import { render, staticRenderFns } from "./DIASRealEstatePart.vue?vue&type=template&id=218aeca8&"
import script from "./DIASRealEstatePart.vue?vue&type=script&lang=js&"
export * from "./DIASRealEstatePart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports